import { t } from "../i18n";

/** Mirrors backend {@code MerchantPortalPasswordPolicy} for client-side hints. */
export function validateMerchantPortalPassword(p) {
  if (p == null || typeof p !== "string" || !p.length) return t("login.password_required");
  if (p.length < 8) return t("password.min_length");
  if (!/[A-Z]/.test(p)) return t("password.uppercase");
  if (!/[a-z]/.test(p)) return t("password.lowercase");
  if (!/[0-9]/.test(p)) return t("password.number");
  if (!/[!@#$%^&*()_+\-=[\]{}|;:,.<>?/~`]/.test(p)) {
    return t("password.special");
  }
  return null;
}
